import VideoPlayer from './VideoPlayer';

export default class Episode {
	constructor(el) {
		this.el = el;
	}

	init() {
		const videoEl = this.el.querySelector('.c-video');

		this.videoPlayer = new VideoPlayer(videoEl);
		this.videoPlayer.init();
	}
}
